import { getLocaleKeyFromLocaleString } from "@faire/retailer-visitor-shared/consts/LANGUAGE";
import { COOKIE_LOCALE_OVERRIDE } from "@faire/web/common/consts/COOKIE_LOCALE_OVERRIDE";
import { getCookies } from "@faire/web/common/cookies";
import { getLocationOrThrow } from "@faire/web/common/globals/getLocation";
import { getWindow } from "@faire/web/common/globals/getWindow";
import { localizePath } from "@faire/web/ui/routing/util";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";

export const assignWithLocale = (path: string) => {
  //This cookie may be set in handleCreateUser()
  const language = getCookies(COOKIE_LOCALE_OVERRIDE);

  /**
   * It is necessary to pushState() first before calling location.assign()
   * to clear the referrer before sending a new request to the backend.
   *
   * When switching to English, we remove the locale from the pathname
   * (ie. https://faire.com/ instead of https://faire.com/en-us/).
   * If the user is not logged-in, and there is no locale in the URL,
   * the backend falls back to checking the referrer for the locale.r
   * For example, if the referrer is https://faire.com/fr the backend
   * will return:
   *   "locale_key":{"country":"FRA","language":"FRA"}
   *
   * Since the user intentionally selected a new language,
   * we need the backend to ignore the referrer from the previous page.
   */
  getWindow()?.history.pushState(null, "", path);

  if (language === undefined) {
    getLocationOrThrow().assign(path);
  } else if (language in Language) {
    getLocationOrThrow().assign(
      localizePath(path, Language[language as keyof typeof Language])
    );
  } else {
    // the locale cookie is in format fr-FR
    const localeKey = getLocaleKeyFromLocaleString(language);
    getLocationOrThrow().assign(
      localizePath(path, Language[localeKey.language!], localeKey)
    );
  }
};
